// Country-aware billing configuration. VAT/tax-id formats are standardized per country,
// so we can validate length/format and adapt labels. SDI + PEC are Italy-only (fatturazione elettronica).
export const BILLING_COUNTRIES = [
  { code: "IT", name: "Italia", vatLabel: "Partita IVA", vatRe: /^\d{11}$/, vatHint: "11 cifre", italy: true },
  { code: "RO", name: "România", vatLabel: "CUI / CIF", vatRe: /^\d{2,10}$/, vatHint: "2–10 cifre" },
  { code: "DE", name: "Germania", vatLabel: "USt-IdNr.", vatRe: /^\d{9}$/, vatHint: "9 cifre" },
  { code: "FR", name: "Francia", vatLabel: "N° TVA", vatRe: /^[A-Z0-9]{2}\d{9}$/, vatHint: "2 caratteri + 9 cifre" },
  { code: "ES", name: "Spagna", vatLabel: "NIF / CIF", vatRe: /^[A-Z0-9]\d{7}[A-Z0-9]$/, vatHint: "9 caratteri" },
  { code: "GB", name: "Regno Unito", vatLabel: "VAT number", vatRe: /^\d{9}(\d{3})?$/, vatHint: "9 o 12 cifre" },
  { code: "NL", name: "Paesi Bassi", vatLabel: "BTW-nummer", vatRe: /^\d{9}B\d{2}$/, vatHint: "es. 123456789B01" },
  { code: "BE", name: "Belgio", vatLabel: "N° TVA", vatRe: /^0?\d{9}$/, vatHint: "10 cifre" },
  { code: "AT", name: "Austria", vatLabel: "UID", vatRe: /^U\d{8}$/, vatHint: "U + 8 cifre" },
  { code: "PT", name: "Portogallo", vatLabel: "NIF", vatRe: /^\d{9}$/, vatHint: "9 cifre" },
  { code: "OTHER", name: "Altro paese", vatLabel: "Partita IVA / VAT", vatRe: null, vatHint: "" },
];

export function billingConfig(code) {
  return BILLING_COUNTRIES.find((c) => c.code === code) || BILLING_COUNTRIES.find((c) => c.code === "OTHER");
}

const clean = (v) => String(v || "").replace(/\s+/g, "").toUpperCase();

// Returns an array of human-readable error messages (empty = valid).
export function validateBilling(country, { vat_number, sdi_code } = {}) {
  const cfg = billingConfig(country);
  const errors = [];
  const vat = clean(vat_number);
  if (vat && cfg.vatRe && !cfg.vatRe.test(vat)) {
    errors.push(`${cfg.vatLabel}: formato non valido (${cfg.vatHint})`);
  }
  if (cfg.italy && sdi_code && !/^[A-Z0-9]{7}$/.test(clean(sdi_code))) {
    errors.push("Codice SDI: 7 caratteri alfanumerici");
  }
  return errors;
}
